// import { StrictMode } from "react";
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './main.css';
import '@ionic/react/css/core.css';
import NiceModal from '@ebay/nice-modal-react';
import { setupIonicReact } from '@ionic/react';

setupIonicReact();

function main() {
  const root = createRoot(document.getElementById('root')!);
  root.render(
    // <StrictMode>
    <NiceModal.Provider>
      <App />
    </NiceModal.Provider>
    // </StrictMode>,
  );
}

main();
